export const projects = [
  {
    img: "https://raw.githubusercontent.com/kushagra-01/random/main/Screenshot%20(50).png",
    title: "TATA 1mg Clone",
    des: "This is the clone of TATA 1mg website. A web application to buy medicines and health products. This is our team collaboration project at Full Stack-development bootcamp in Masai School.",
    demo: "",
    live: "https://tata1mg.netlify.app/",
    gitHub: "https://github.com/rohan688/tata-Mg1-clone",
    technologies: ["HTML", "CSS", "JavaScript","NodeJS","ExpressJS","MongoDB"],
  },
  {
    img: "https://raw.githubusercontent.com/Aniket-Pilankar/Amazon-Prime-Video-Clone/main/Amazon-Prime-Video-Clone/Screenshot/4.jpg",
    title: "Prime Video's Clone",
    des: "This is the clone of Prime Video website , which is an website for watchiing movies. This is our team collaboration project at Full Stack-development bootcamp in Masai School.",
    demo: "",
    live: "https://amazon-prime-video-clone-theta.vercel.app/",
    gitHub: "https://github.com/Aniket-Pilankar/Amazon-Prime-Video-Clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "NodeJS",
      "ExpressJS",
      "MongoDB"
     
    ],
  },
 
  {
    img: "https://raw.githubusercontent.com/kushagra-01/random/main/ddefaeee-025b-4370-9180-bb63b48b47ea.jpg",
    title: "Kohl's Clone",
    des: "This is the clone of Kohl's Shopping website , which is an e-commerce website of a Cloathings. This is our team collaboration project at Full Stack-development bootcamp in Masai School.",
    demo: "",
    live: "https://frosty-beaver-3fcf9f.netlify.app/",
    gitHub: "https://github.com/Asutosh17/kohl-s-clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
     
    ],
  }
 
];
